import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Divider,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";

function RuleForm({ inputs, outputs, onCancel, addRule, editScreen = false }) {
  const columns = [...inputs, ...outputs];
  const [errors, setErrors] = useState({});
  const [nameError, setNameError] = useState("");
  const [priorityError, setPriorityError] = useState("");

  const textFieldRefs = useRef([]);
  const nameRef = useRef(null);
  const priorityRef = useRef(null);
  const handleSubmit = () => {
    const newErrors = {}; // To store errors during validation
    let newNameError = "";
    let newpriorityError = "";

    if (!nameRef.current.value.trim()) newNameError = "Rule name is required.";
    if (!priorityRef.current.value.trim())
      newpriorityError = "Rule priority is required.";
    textFieldRefs.current.forEach((ref, index) => {
      if (!ref.value.trim()) {
        newErrors[index] = `${columns[index].ruleConfigFieldName} is required`;
      }
    });

    setNameError(newNameError);
    setPriorityError(newpriorityError);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const rule = {
        name: nameRef.current.value,
        priority: priorityRef.current.value,
      };
      textFieldRefs.current.forEach((ref, index) => {
        rule[columns[index].ruleConfigFieldKey] = ref.value;
      });
      addRule(rule);
    }
  };
  return (
    <Dialog open={true} fullWidth maxWidth="lg">
      <DialogTitle>Create Rule</DialogTitle>
      <DialogContent>
        <div>
          <TextField
            sx={(theme) => ({ margin: theme.spacing(1) })}
            label={"Rule Name"}
            inputRef={nameRef}
            error={!!nameError}
            helperText={nameError}
          />
          <TextField
            sx={(theme) => ({ margin: theme.spacing(1) })}
            label={"Rule Priority"}
            inputRef={priorityRef}
            error={!!priorityError}
            helperText={priorityError}
          />
        </div>
        <Divider />
        <Typography>Inputs:</Typography>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {inputs.map((c, index) => {
            return (
              <TextField
                sx={(theme) => ({ margin: theme.spacing(1) })}
                key={c.ruleConfigFieldName}
                label={c.ruleConfigFieldName}
                inputRef={(el) => (textFieldRefs.current[index] = el)}
                error={!!errors[index]}
                helperText={errors[index]}
              />
            );
          })}
        </div>
        <Divider />

        <Typography>Outputs:</Typography>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {outputs.map((c, index) => {
            return (
              <TextField
                sx={(theme) => ({ margin: theme.spacing(1) })}
                key={c.ruleConfigFieldName}
                label={c.ruleConfigFieldName}
                inputRef={(el) =>
                  (textFieldRefs.current[index + inputs.length] = el)
                }
                error={!!errors[index + inputs.length]}
                helperText={errors[index + inputs.length]}
              />
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleSubmit}>{editScreen ? "Save" : "Add"}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default RuleForm;
